import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../assets/imgs/comfirme-person.svg';
const _withScopeId = n => (_pushScopeId("data-v-6ba87346"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "myperConfirm"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "perConfirm-title"
}, "请填写个人资料", -1));
const _hoisted_3 = {
  class: "perConfirm-body"
};
const _hoisted_4 = {
  key: 0,
  class: "login-container"
};
const _hoisted_5 = {
  class: "loginall-bodyclose"
};
const _hoisted_6 = {
  class: "loginall-bodytitle"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "或点击头像授权实名认证", -1));
const _hoisted_8 = {
  class: "loginall-bodypart1"
};
const _hoisted_9 = {
  class: "loginall-bodypart2"
};
const _hoisted_10 = ["src"];
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "105px"
  }
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {
    "height": "85px",
    "width": "85px",
    "margin": "10px 0px 0px 10px"
  }
})], -1));
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "loginall-text"
}, [/*#__PURE__*/_createElementVNode("div", null, "请使用已实名的QQ扫码"), /*#__PURE__*/_createElementVNode("div", null, "认证填写的个人信息真实性")], -1));
const _hoisted_13 = {
  key: 1
};
const _hoisted_14 = {
  key: 0,
  class: "login-container3"
};
const _hoisted_15 = {
  class: "loginall-body3"
};
const _hoisted_16 = {
  class: "loginall-text3"
};
const _hoisted_17 = {
  style: {
    "margin-left": "-30px"
  }
};
const _hoisted_18 = {
  style: {
    "margin-left": "-30px"
  }
};
const _hoisted_19 = {
  key: 1
};
const _hoisted_20 = {
  key: 0,
  class: "login-container2"
};
const _hoisted_21 = {
  class: "loginall-body2"
};
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "loginall-text2"
}, [/*#__PURE__*/_createElementVNode("div", {
  style: {
    "margin-left": "-30px",
    "padding-top": "12px"
  }
}, " 已认证成功 ")], -1));
const _hoisted_23 = {
  key: 1,
  class: "login-container3"
};
const _hoisted_24 = {
  class: "loginall-body3"
};
const _hoisted_25 = {
  class: "loginall-text3"
};
const _hoisted_26 = {
  style: {
    "margin-left": "-30px"
  }
};
const _hoisted_27 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "margin-left": "-30px"
  }
}, " 请确认填写信息与认证身份信息是否一致 ", -1));
const _hoisted_28 = {
  style: 'padding-top: 35px; padding-left: 100px'
};
const _hoisted_29 = {
  style: 'display: flex; padding-top: 10px; padding-left: 100px'
};
import { ref, reactive, onMounted, onDeactivated } from 'vue';
import { MessagePlugin } from 'tdesign-vue-next';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { REG_TYPES } from '@/utils/index';
import { QCInfo } from '@/utils/qqInfo.js';
import { IS_DEV } from '@/config/env';
import { addDeveloper, getAuthCode, confirmRealName } from '@/http/api';
import router from '@/router';
export default {
  __name: 'PersonalConfirm',
  setup(__props) {
    let store = useStore();
    const $router = useRouter();
    const iframeSrc = encodeURI(IS_DEV ? QCInfo.beta.verify_url : QCInfo.prod.verify_url);
    const form = ref(null);
    const formData = reactive({
      developerName: '',
      IDCardNum: '',
      phoneNum: '',
      verifyNum: '',
      email: '',
      address: '',
      confirmReal: ''
    });
    const checked1 = ref(false);
    const checked2 = ref(false);
    const isVerify = ref(false);
    const delayCode = ref(false);
    const codeTimeFlag = ref(false);
    const iframeStatus = ref(false);
    let resConfirmReal = reactive({
      isCert: 0,
      // 是否实名认证： 0-未实名认证； 1-已实名认证
      isMatch: 0,
      // 实名信息是否匹配：0 - 不匹配； 1 - 匹配
      msg: '',
      certUrl: '',
      isConfirmed: false
    });
    const goCheck = () => {
      $router.push({
        path: '/chooseidentity'
      });
    };
    const linkClick = async value => {
      localStorage.setItem('agreementItem', value);
      window.open('/software-platform/useragreement');
    };
    const getCode = async () => {
      const mobile = formData.phoneNum;
      if (!mobile) {
        MessagePlugin.warning('请填写手机号再获取验证码！');
        return;
      }
      const paramData = {
        mobile
      };
      const res = await getAuthCode(paramData);
      if (res.result && res.forwardData === 0) {
        MessagePlugin.success('获取手机验证码成功！');
      } else {
        MessagePlugin.error('获取手机验证码失败！');
      }
      codeTimeFlag.value = true;
      setTimeout(() => {
        codeTimeFlag.value = false;
      }, 1000 * 60);
    };
    const checkCode = async () => {
      const mobile = formData.phoneNum;
      const code = formData.verifyNum;
      if (mobile && code) {
        const paramData = {
          mobile,
          code
        };
        const res = await getAuthCode(paramData);
        if (res.result && res.forwardData === 0) {
          MessagePlugin.success('短信验证通过！');
          isVerify.value = true;
        } else {
          MessagePlugin.error('短信验证失败！');
        }
      }
    };
    onMounted(() => {
      window.addEventListener('message', handleMessage, false);
      setTimeout(() => {
        delayCode.value = true;
      }, 2000);
    });
    onDeactivated(() => {
      window.removeEventListener('message', handleMessage, false);
    });
    const reConfirm = () => {
      resConfirmReal.isConfirmed = false;
      resConfirmReal.isCert = 0;
      resConfirmReal.isMatch = 0;
    };
    const gotoConfirm = () => {
      if (!formData.developerName || !formData.IDCardNum) {
        MessagePlugin.warning('认证的身份证号和姓名必须填写');
        return;
      }
      setTimeout(() => {
        iframeStatus.value = true;
      }, 200);
    };
    const gotoClose = () => {
      iframeStatus.value = false;
    };
    const toConfirm = () => {
      const certUrl = resConfirmReal.certUrl;
      window.open(certUrl);
    };
    const handleMessage = async e => {
      let data = e.data;
      if (data && data.type && data.type == 'sendVerifyCode') {
        let {
          code
        } = data.data;
        const paramData = {
          name: formData.developerName,
          certId: formData.IDCardNum,
          code
        };
        const res = await confirmRealName(paramData);
        if (res.result && res.data) {
          const data = res.data;
          resConfirmReal.isConfirmed = true;
          resConfirmReal.isCert = data.isCert;
          resConfirmReal.isMatch = data.isMatch;
          resConfirmReal.msg = data.msg;
          resConfirmReal.certUrl = data.certUrl;
          if (data.isCert == 1 && data.isMatch == 1) {
            formData.confirmReal = 'true';
          } else {
            formData.confirmReal = '';
          }
        }
      }
      iframeStatus.value = false;
    };
    const rules = {
      developerName: [{
        required: true,
        message: '姓名不能为空',
        type: 'error',
        trigger: 'blur'
      }, {
        pattern: REG_TYPES.limits.pattern,
        message: REG_TYPES.limits.message,
        trigger: 'blur'
      }],
      IDCardNum: [{
        required: true,
        message: '身份证号码不能为空',
        type: 'error',
        trigger: 'blur'
      }, {
        pattern: REG_TYPES.idCard.pattern,
        message: REG_TYPES.idCard.message,
        trigger: 'blur'
      }],
      phoneNum: [{
        required: true,
        message: '手机号码不能为空',
        type: 'error',
        trigger: 'blur'
      }, {
        pattern: REG_TYPES.mobile.pattern,
        message: REG_TYPES.mobile.message,
        trigger: 'blur'
      }],
      email: [{
        required: true,
        message: '邮箱不能为空',
        type: 'error',
        trigger: 'blur'
      }, {
        pattern: REG_TYPES.email.pattern,
        message: REG_TYPES.email.message,
        trigger: 'blur'
      }],
      address: [{
        required: true,
        message: '联系地址不能为空',
        type: 'error',
        trigger: 'blur'
      }],
      confirmReal: [{
        required: true,
        message: '请用已实名的QQ扫码认证填写的个人信息真实性',
        type: 'error',
        // trigger: 'all'
        trigger: 'change'
      }]
    };
    const onSubmit = async ({
      validateResult,
      firstError,
      e
    }) => {
      e.preventDefault();
      // 水滴 选择认证页-个人认证按钮点击
      window._sdi.stat({
        ptype: '9',
        stype: '3'
      });
      const identityType = 1;
      const linkman = formData.developerName;
      if (validateResult === true) {
        if (!isVerify.value) {
          MessagePlugin.warning('请使用手机短信验证通过后再提交！');
          return;
        }
        if (!checked1.value) {
          MessagePlugin.warning('请确认信息真实性！');
          return;
        }
        if (!checked2.value) {
          MessagePlugin.warning('请同意腾讯电脑管家软件提供者服务协议！');
          return;
        }

        // isVerify.value = true
        const paramData = {
          identity_type: 1,
          linkman: formData.developerName,
          identity_code: formData.IDCardNum,
          user_phone: formData.phoneNum,
          user_email: formData.email,
          user_address: formData.address
        };
        const res = await addDeveloper(paramData);
        if (res && res.result && res.realInfoRes) {
          MessagePlugin.success('用户信息认证成功');
          const userStr = localStorage.getItem('user');
          let tempUser = {};
          if (userStr) {
            tempUser = JSON.parse(userStr);
          }
          tempUser.identityType = identityType;
          tempUser.confirmed = 1;
          let resVague = '';
          if (linkman.length == 2) {
            resVague = linkman.substring(0, 1) + '*';
          } else {
            resVague = linkman.substring(0, 1) + '*' + linkman.substring(linkman.length - 1, linkman.length);
          }
          tempUser.vagueName = resVague;
          localStorage.setItem('user', JSON.stringify(tempUser));
          router.push({
            path: '/softwarelibrary'
          });
        } else {
          MessagePlugin.error('用户信息认证失败');
        }
      } else {
        console.log('Validate Errors: ', firstError, validateResult);
        MessagePlugin.warning(firstError);
      }
    };
    return (_ctx, _cache) => {
      const _component_t_breadcrumbItem = _resolveComponent("t-breadcrumbItem");
      const _component_t_breadcrumb = _resolveComponent("t-breadcrumb");
      const _component_t_input = _resolveComponent("t-input");
      const _component_t_form_item = _resolveComponent("t-form-item");
      const _component_t_link = _resolveComponent("t-link");
      const _component_t_icon = _resolveComponent("t-icon");
      const _component_t_checkbox = _resolveComponent("t-checkbox");
      const _component_t_button = _resolveComponent("t-button");
      const _component_t_space = _resolveComponent("t-space");
      const _component_t_form = _resolveComponent("t-form");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", {
        style: _normalizeStyle([{
          "height": "1200px",
          "width": "100%",
          "position": "absolute",
          "top": "0",
          "left": "0",
          "background": "#000000",
          "opacity": "0.5",
          "z-index": "90"
        }, iframeStatus.value ? '' : 'display: none'])
      }, null, 4), _createElementVNode("div", _hoisted_1, [_createVNode(_component_t_breadcrumb, {
        style: {
          "width": "680px",
          "margin": "auto",
          "padding-top": "52px"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_t_breadcrumbItem, {
          style: {
            "color": "#000"
          },
          onClick: goCheck
        }, {
          default: _withCtx(() => [_createTextVNode("选择认证方式")]),
          _: 1
        }), _createVNode(_component_t_breadcrumbItem, {
          disabled: ""
        }, {
          default: _withCtx(() => [_createTextVNode("填写信息")]),
          _: 1
        })]),
        _: 1
      }), _hoisted_2, _createElementVNode("div", _hoisted_3, [_createVNode(_component_t_form, {
        ref_key: "form",
        ref: form,
        data: formData,
        rules: rules,
        onSubmit: onSubmit
      }, {
        default: _withCtx(() => [_createVNode(_component_t_form_item, {
          style: 'padding-top: 55px',
          label: "姓名",
          name: "developerName",
          labelAlign: "left"
        }, {
          default: _withCtx(() => [_createVNode(_component_t_input, {
            modelValue: formData.developerName,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => formData.developerName = $event),
            placeholder: "请输入姓名",
            disabled: _unref(resConfirmReal).isConfirmed && _unref(resConfirmReal).isCert == 1 && _unref(resConfirmReal).isMatch == 1
          }, null, 8, ["modelValue", "disabled"])]),
          _: 1
        }), _createVNode(_component_t_form_item, {
          style: 'padding-top: 35px',
          label: "身份证",
          name: "IDCardNum",
          labelAlign: "left"
        }, {
          default: _withCtx(() => [_createVNode(_component_t_input, {
            modelValue: formData.IDCardNum,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => formData.IDCardNum = $event),
            placeholder: "请输入有效身份证号",
            disabled: _unref(resConfirmReal).isConfirmed && _unref(resConfirmReal).isCert == 1 && _unref(resConfirmReal).isMatch == 1
          }, null, 8, ["modelValue", "disabled"])]),
          _: 1
        }), _createVNode(_component_t_form_item, {
          style: {
            "padding-top": "35px"
          },
          label: "实名认证",
          name: "confirmReal",
          labelAlign: "left"
        }, {
          default: _withCtx(() => [_createVNode(_component_t_input, {
            style: {
              "display": "none"
            },
            modelValue: formData.confirmReal,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => formData.confirmReal = $event),
            placeholder: ""
          }, null, 8, ["modelValue"]), !_unref(resConfirmReal).isConfirmed ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("div", {
            class: "loginall-body",
            style: _normalizeStyle(delayCode.value ? '' : 'opacity: 0')
          }, [_createElementVNode("div", {
            style: _normalizeStyle([iframeStatus.value ? '' : 'visibility: hidden', {
              "position": "absolute",
              "top": "-150px",
              "z-index": "99",
              "margin-left": "-21px",
              "width": "480px",
              "height": "360px",
              "background": "rgb(255, 255, 255)",
              "padding": "20px 0px 0px",
              "border-radius": "10px"
            }])
          }, [_createElementVNode("div", _hoisted_5, [_createVNode(_component_t_link, {
            onClick: gotoClose,
            theme: "primary",
            hover: "color",
            style: _normalizeStyle([{
              "position": "absolute"
            }, iframeStatus.value ? '' : 'display: none'])
          }, {
            default: _withCtx(() => [_createTextVNode(" 关闭 ")]),
            _: 1
          }, 8, ["style"])]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", null, [_createTextVNode(" 请使用 "), _createVNode(_component_t_link, {
            theme: "primary",
            hover: "color",
            href: "https://im.qq.com/mobileqq/#from=login",
            target: "_blank",
            style: {
              "font-size": "14px"
            }
          }, {
            default: _withCtx(() => [_createTextVNode("QQ手机版")]),
            _: 1
          }), _createTextVNode(" 扫描二维码， ")]), _hoisted_7]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("iframe", {
            id: "qq_login_frame",
            src: _unref(iframeSrc),
            width: "800",
            height: "600",
            scrolling: "no"
          }, "\n                    ", 8, _hoisted_10)])])], 4)], 4), _hoisted_11, _hoisted_12, _createVNode(_component_t_link, {
            onClick: gotoConfirm,
            style: {
              "font-size": "16px",
              "width": "75px"
            },
            theme: "primary",
            hover: "color"
          }, {
            default: _withCtx(() => [_createTextVNode(" 去认证 ")]),
            _: 1
          })])) : _createCommentVNode("", true), _unref(resConfirmReal).isConfirmed ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_unref(resConfirmReal).isCert == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_createVNode(_component_t_icon, {
            name: "error-circle-filled",
            style: {
              "height": "42px",
              "width": "42px",
              "color": "#f24014"
            }
          })]), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_createTextVNode(" 认证失败 "), _createVNode(_component_t_link, {
            onClick: reConfirm,
            style: {
              "font-size": "16px"
            },
            theme: "primary",
            hover: "color"
          }, {
            default: _withCtx(() => [_createTextVNode(" 重新认证 ")]),
            _: 1
          })]), _createElementVNode("div", _hoisted_18, [_createTextVNode(" 请确认账号是否完成实名认证 "), _createVNode(_component_t_link, {
            onClick: toConfirm,
            style: {
              "font-size": "16px"
            },
            theme: "primary",
            hover: "color"
          }, {
            default: _withCtx(() => [_createTextVNode("去实名认证")]),
            _: 1
          })])])])) : _createCommentVNode("", true), _unref(resConfirmReal).isCert == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_19, [_unref(resConfirmReal).isMatch == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, [_createVNode(_component_t_icon, {
            name: "check-circle-filled",
            style: {
              "height": "42px",
              "width": "42px",
              "color": "#00be63"
            }
          })]), _hoisted_22])) : _createCommentVNode("", true), _unref(resConfirmReal).isMatch == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_23, [_createElementVNode("div", _hoisted_24, [_createVNode(_component_t_icon, {
            name: "error-circle-filled",
            style: {
              "height": "42px",
              "width": "42px",
              "color": "#f24014"
            }
          })]), _createElementVNode("div", _hoisted_25, [_createElementVNode("div", _hoisted_26, [_createTextVNode(" 认证失败 "), _createVNode(_component_t_link, {
            onClick: reConfirm,
            style: {
              "font-size": "16px"
            },
            theme: "primary",
            hover: "color"
          }, {
            default: _withCtx(() => [_createTextVNode(" 重新认证")]),
            _: 1
          })]), _hoisted_27])])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)]),
          _: 1
        }), _createVNode(_component_t_form_item, {
          style: 'padding-top: 35px',
          label: "联系电话",
          name: "phoneNum",
          labelAlign: "left"
        }, {
          default: _withCtx(() => [_createVNode(_component_t_input, {
            disabled: isVerify.value,
            modelValue: formData.phoneNum,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => formData.phoneNum = $event),
            maxlength: "11",
            placeholder: "请输入手机号"
          }, null, 8, ["disabled", "modelValue"]), _createVNode(_component_t_link, {
            disabled: isVerify.value || codeTimeFlag.value,
            theme: "primary",
            hover: "color",
            onClick: _cache[4] || (_cache[4] = $event => getCode()),
            style: {
              "position": "absolute",
              "right": "15px",
              "z-index": "9"
            }
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(codeTimeFlag.value ? '重新发送' : '获取验证码'), 1)]),
            _: 1
          }, 8, ["disabled"])]),
          _: 1
        }), _createVNode(_component_t_form_item, {
          style: 'padding-top: 35px',
          label: "",
          labelAlign: "left"
        }, {
          default: _withCtx(() => [_createVNode(_component_t_input, {
            disabled: isVerify.value,
            modelValue: formData.verifyNum,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => formData.verifyNum = $event),
            placeholder: "请输入手机验证码",
            maxlength: "10"
          }, null, 8, ["disabled", "modelValue"]), _createVNode(_component_t_link, {
            disabled: isVerify.value,
            onClick: _cache[6] || (_cache[6] = $event => checkCode()),
            theme: "primary",
            hover: "color",
            style: {
              "position": "absolute",
              "right": "15px",
              "z-index": "9"
            }
          }, {
            default: _withCtx(() => [_createTextVNode(" 确认验证 ")]),
            _: 1
          }, 8, ["disabled"])]),
          _: 1
        }), _createVNode(_component_t_form_item, {
          style: 'padding-top: 35px',
          label: "联系邮箱",
          name: "email",
          labelAlign: "left"
        }, {
          default: _withCtx(() => [_createVNode(_component_t_input, {
            modelValue: formData.email,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => formData.email = $event),
            placeholder: "请输入日常使用的邮箱地址，方便我们联系您",
            maxlength: "56"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_t_form_item, {
          style: 'padding-top: 35px',
          label: "联系地址",
          name: "address",
          labelAlign: "left"
        }, {
          default: _withCtx(() => [_createVNode(_component_t_input, {
            modelValue: formData.address,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => formData.address = $event),
            placeholder: "示例：深圳市南山区深南大道xx号x号楼x单元xxx",
            maxlength: "48"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createElementVNode("div", _hoisted_28, [_createVNode(_component_t_checkbox, {
          modelValue: checked1.value,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => checked1.value = $event)
        }, {
          default: _withCtx(() => [_createTextVNode("我确认以上信息真实性，并同意平台审核及留存")]),
          _: 1
        }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_29, [_createVNode(_component_t_checkbox, {
          modelValue: checked2.value,
          "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => checked2.value = $event)
        }, {
          default: _withCtx(() => [_createTextVNode("同意")]),
          _: 1
        }, 8, ["modelValue"]), _createElementVNode("div", null, [_createVNode(_component_t_link, {
          theme: "primary",
          hover: "color",
          onClick: _cache[11] || (_cache[11] = $event => linkClick('item2'))
        }, {
          default: _withCtx(() => [_createTextVNode("腾讯电脑管家软件开放平台开发者协议")]),
          _: 1
        })])]), _createVNode(_component_t_form_item, {
          style: 'padding-top: 40px'
        }, {
          default: _withCtx(() => [_createVNode(_component_t_space, {
            size: "small"
          }, {
            default: _withCtx(() => [_createVNode(_component_t_button, {
              style: 'width: 150px',
              theme: "primary",
              type: "submit"
            }, {
              default: _withCtx(() => [_createTextVNode("提交")]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["data"])])])], 64);
    };
  }
};